import React, { useEffect, useState } from "react";
import CardMembership from "../../CardMembership/CardMembership";
import { Box } from "@mui/material";
import Loading from "../../Loading/Loading";
import { getAllMemberships } from "../../../services/rest/membership/membershipService";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const ListMembershipUser = () => {
  const { userType } = useSelector((state) => state.userReducer);
  const [loading, setLoading] = useState(true);
  const [memberships, setMemberships] = useState([]);
  const [selectedMembership, setSelectedMembership] = useState(2);

  useEffect(() => {
    const getAllMembershipsOfUser = async () => {
      try {
        //Dependiendo del tipo de usuario se hara la peticion a la api con el user Type para traer las membresias
        const memberships = await getAllMemberships();
        const filterMembershps = [];
        memberships.forEach((membership) => {
          if (membership?.typeUser === userType && membership?.active) {
            if (membership?.planName !== "Free") {
              filterMembershps.push(membership);
            }
          }
        });
        setMemberships(filterMembershps);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error al cargar las membresías");
      }
    };
    getAllMembershipsOfUser();
  }, [userType]);
  return (
    <Box sx={{ paddingLeft: 4, paddingRight: 4 }}>
      <Loading loading={loading} />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(auto-fit, minmax(300px, 1fr))",
          },
          gap: 4,
          justifyItems: "center",
        }}
      >
        {memberships &&
          memberships.map((membership) => (
            <CardMembership
              key={membership._id}
              membership={membership}
              selected={membership._id === selectedMembership}
              setSelected={setSelectedMembership}
              landing={false}
              setLoading={setLoading}
            />
          ))}
      </Box>
    </Box>
  );
};

export default ListMembershipUser;
